/* 布局 */
//前台
import Layout from "@views/layout";

const ebookapplyRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "ebookapply",
            name: "EBOOKAPPLY",
            meta: {
                title: "电子期刊投稿管理",
                sort: 1,
            },
            component: () => import("@views/business/ebookapply/index.vue"),
            redirect: {
                name: "EBOOKAPPLY_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "EBOOKAPPLY_LIST",
                    meta: {
                        title: "电子期刊投稿管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/ebookapply/list.vue"),
                },
                                                        ],
    },


        ],
};

export default ebookapplyRouter;
